import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {getCustomTag} from '../reducers/custom-material';
import soundTags from '../lib/libraries/sound-tags';
import messages from '../lib/libraries/tag-messages.js';


const SoundLibraryHOC = WrappedComponent => {
    class SoundLibraryComponent extends React.Component {
        componentDidMount () {
            if (!Array.isArray(this.props.customTags)) {
                this.props.getCustomTag();
            }
        }

        render () {
            const {
                sounds,
                customTags,
                ...componentProps
            } = this.props;

            let customData = [];

            if (Array.isArray(sounds)) {
                // let data = sounds.map(item => ({...item, info: item.info.split(',')}));
                customData = sounds;
            }

            let finalTags = [];

            if (Array.isArray(customTags)) {
                finalTags = [...(customTags.map(tag => ({
                    tag: tag.replace(/\s/g, '_'), intlLabel: messages[tag.replace(/\s/g, '_')]
                }))), ...soundTags];
            } else {
                finalTags = [...soundTags];
            }

            return (
                <WrappedComponent
                    data={customData}
                    tags={finalTags}
                    {...componentProps}
                />
            );
        }
    }

    SoundLibraryComponent.propTypes = {
        sounds: PropTypes.array,
        customTags: PropTypes.array,
        getCustomTag: PropTypes.func
    };

    const mapStateToProps = state => ({
        sounds: state.scratchGui.customMaterial.sounds,
        customTags: state.scratchGui.customMaterial.tags
    });

    const mapDispatchToProps = dispatch => ({
        getCustomTag: () => dispatch(getCustomTag())
    });

    return injectIntl(connect(
        mapStateToProps,
        mapDispatchToProps
    )(SoundLibraryComponent));
};

export default SoundLibraryHOC;
